<template>
    <div class="gov-title">
        <div class="addTitle">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
        </div>
        <div class="infoServe">
            <el-table :data="tableData" border style="width: 100%; margin-top: 20px"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
                <el-table-column type="index" width="70" label="序号" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equTypeName" label="设备类型" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equBrandName" label="设备品牌" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equNo" label="设备号" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equName" label="设备名称" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-tooltip
                        class="item"
                        effect="light"
                        content="查看"
                        placement="top-start"
                        >
                        <button
                            style="color: #199b5d;"
                            class="iconfont icon-chakan tabBtn"
                            @click="showDialogForm(scope.row,'look')"
                        ></button>
                        </el-tooltip>
                        <el-tooltip
                        class="item"
                        effect="light"
                        content="修改"
                        placement="top-start"
                        v-if="scope.row.auditStatus != 1"
                        >
                        <button
                            style="color: #2e99cf;"
                            class="iconfont icon-bianji3 tabBtn"
                            @click="showDialogForm(scope.row,'edit')"
                        ></button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="pages" background layout="total, prev, pager, next"
                @current-change="handleCurrentChangeOne" :total="pageOne.total" :current-page.sync="pageOne.pageNo"
                :page-size="10">
            </el-pagination>
        </div>
        <!-- 添加或修改配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="设备类型" prop="equTypeId">
                    <el-select v-model="form.equTypeId" placeholder="请选择设备类型" style="width:100%" :disabled="title=='查看设备'">
                        <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictLabel" :value="item.dictCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备品牌" prop="equBrandId">
                    <el-select v-model="form.equBrandId" placeholder="请选择设备品牌" style="width:100%" :disabled="title=='查看设备'">
                        <el-option v-for="item in prodList" :key="item.dictCode" :label="item.dictLabel" :value="item.dictCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备号" prop="equNo">
                    <el-input v-model="form.equNo" type="text" placeholder="请输入" :disabled="title=='查看设备'"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" prop="equName">
                    <el-input v-model="form.equName" type="text" placeholder="请输入" :disabled="title=='查看设备'"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import exportVue from "@/utils/exportVue"
export default {
    props: {
        formData: {
            type:Object,
            default: () => ({
                id:''
            })
        },
       
        serviceStation: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            pageOne: { pageNo: 1, pageSize: 10, total: 0 },
            tableData: [],
            typeList: [],
            prodList: [],
            data: {},
            form: {
                equTypeId:'',
                equBrandId:'',
                equNo:'',
                equName:'',
                status:1
            },
            open:false,
            title:'',
            addForm:{id:''},
             rules: {
                equTypeId: [
                { required: true, message: "设备类型不能为空", trigger: "blur" }
                ],
                equBrandId: [
                { required: true, message: "设备品牌不能为空", trigger: "blur" }
                ],
                equNo: [
                { required: true, message: "设备号不能为空", trigger: "blur" }
                ]
        }
        }
    },
    async created() {
        exportVue.$on("oldInfo", (data) => {
            this.customerId = data
              this.getList()
        })
        await this.getType()
        await this.getProd()
       
    },
    watch: {
        formData: {
            handler(val) {
                this.addForm = val;
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        handleAdd() {
          this.open=true
          this.title='新增设备'
        },
        showDialogForm(val,type){
            if(type=='look'){
                this.title='查看设备'
            }else{
                this.title='修改设备'
            }
            this.open=true
            this.form=val
            this.form.equBrandId=String(this.form.equBrandId)
            this.form.equTypeId=String(this.form.equTypeId)
        },
        // 设备类型
        getType() {
             let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "equ_brand",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.typeList = res.rows
                            this.typeList.forEach((item) => {
                                item.dictCode = String(item.dictCode)
                            })
                        }
                    }
                })
        },
        //设备品牌
        getProd() {
             let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "equ_type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.prodList = res.rows
                            this.prodList.forEach((item) => {
                                item.dictCode = String(item.dictCode)
                            })
                        }
                    }
                })
        },
        getList(){
            this.$http
                .request({
                    url: "/jjyl/admin/center/customer/info/findEquList",
                    method: "post",
                    data: {
                        pageNo: this.pageOne.pageNo,
                        pageSize: this.pageOne.pageSize,
                        customerId:this.customerId
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if(res.content){
                            this.tableData = res.content.list
                         this.pageOne.total = res.content.count || 0
                        }
                    }
                })
        },
         submitForm: function() {
            let that=this
             if(!that.customerId){
                that.$message.warning('请先选择老人')
                return false
            }
            this.$refs["form"].validate(valid => {
                if (valid) {
                    let url=''
                    let infoS=''
                     if(that.title=='新增设备'){
                       url='/jjyl/admin/center/customer/info/insertEqu'
                       infoS='新增成功'
                     }else{
                        url='/jjyl/admin/center/customer/info/updateEqu'
                        infoS='修改成功'
                     }
                     this.form.customerId=that.customerId
                     this.$http
                        .request({
                            url: url,
                            method: 'post',
                            data: this.form
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                if (res.content == null || res.content == 'null') {
                                   this.msgSuccess(infoS);
                                }
                                this.open=false
                                this.getList()
                            }
                        })
                }
            })
        },
        cancel(){
         this.open=false;
        },
        handleCurrentChangeOne() {
            this.pageOne.pageNo = val
        },
        wUpdata() {
            // this.addForm.projectTypeDesc = this.$refs.zfyzTypeName.selectedLabel
            // this.addForm.entityStatusDesc =
            //     this.$refs.zfyzStatusName.selectedLabel
            this.addForm.entityStationName = this.$refs.zfyzEntityName.selectedLabel

            this.addForm.entityServicePersonName =
                this.$refs.zfyzServeName.selectedLabel
            this.getPerson(this.addForm.serviceStation)
            // this.addForm.projectType = this.addForm.projectType.split(",")

            this.$emit("governmentAssistance", this.addForm)
        },
    },
}
</script>

<style lang="less" scoped>
.gov-title {
    width: 98%;
    margin-left: 2%;
}

.pages {
    margin-top: 20px;
}

.addTitle {
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    display: flex;
    line-height: 40px;

    .fontSize {
        font-weight: bold;
        color: #409eff;
        line-height: 40px;
        cursor: pointer;
    }
}

.infoServe {
    margin-top: 20px;

    .infoItem {
        display: flex;
        flex-wrap: wrap;

        .serveFlex {
            width: 25%;
            margin-bottom: 15px;

            .serveContent {
                padding: 0 15px;
                display: flex;

                // margin-bottom: 10px;
                .serveName {
                    width: 90px;
                    padding-right: 10px;
                    text-align: right;
                    color: #606266;
                    font-size: 14px;
                    line-height: 40px;
                }

                .serveSign {
                    flex: 1;
                }
            }
        }

        .delIcon {
            cursor: pointer;
            font-size: 20px;
            position: relative;
            top: 10px;
        }
    }
}

.entityServe {
    margin-top: 20px;
    border-top: 1px solid rgba(167, 164, 164, 0.8);
}

.right-title-6 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #c0c4cc;
    border-left: 1px solid #c0c4cc;
    background-color: #eeeeee;
}

.rightTitle {
    width: 140px;
    // height: 100%;
    text-align: center;
    position: relative;

    p {
        position: absolute;
        width: 100%;
        left: 0;
        top: 47%;
    }
}

.rightBox {
    background: #fff;
    border-left: 1px solid #c0c4cc;
    flex: 1;
    padding: 10px;
    line-height: 30px;
}
</style>
